function attachRelatedProductsCustomArrows(slider, instance) {
  const prevButtons = slider.querySelectorAll('[data-related-arrow="prev"]');
  const nextButtons = slider.querySelectorAll('[data-related-arrow="next"]');

  prevButtons.forEach((button) => {
    button.addEventListener('click', () => instance.go('<'));
  });

  nextButtons.forEach((button) => {
    button.addEventListener('click', () => instance.go('>'));
  });
}

function mountRelatedProductsSplides(root = document) {
  root.querySelectorAll('.related-products-splide').forEach((slider) => {
    if (slider.dataset.splideInitialized === 'true') return;

    const perPageDesktop = parseInt(slider.dataset.perPageDesktop, 10) || 4;
    const perPageMobile = parseInt(slider.dataset.perPageMobile, 10) || 1;
    const gap = slider.dataset.gap || '10px';

    const instance = new Splide(slider, {
      type: 'loop',
      arrows: true,
      pagination: false,
      perPage: perPageDesktop,
      perMove: 1,
      gap,
      breakpoints: {
        1200: {
          perPage: Math.max(2, Math.min(3, perPageDesktop)),
        },
        900: {
          perPage: Math.max(2, perPageMobile),
        },
        600: {
          perPage: perPageMobile,
        },
      },
    }).mount();

    slider.dataset.splideInitialized = 'true';
    attachRelatedProductsCustomArrows(slider, instance);
  });
}

function initSliders() {
  // --- Vertical Text Slider ---
  document.querySelectorAll('.vertical-text-slider').forEach((slider) => {
    new Splide(slider, {
      type: 'loop',
      arrows: false,
      pagination: false,
      direction: 'ttb',
      height: '1.1em',
      autoHeight: true,
      perPage: 1,
      autoplay: true,
      interval: 2000,
      wheel: false,
      drag: false,
    }).mount();
  });

  // --- Icon List Slider ---
  const iconListSlider = document.querySelector('.icon-list-slider');
  if (iconListSlider) {
    new Splide(iconListSlider, {
      type: 'slide',
      arrows: true,
      pagination: false,
      perPage: 7,
      perMove: 1,
      autoplay: true,
      breakpoints: {
        1359: { perPage: 6 },
        900: { perPage: 5 },
        767: { perPage: 4 },
        600: { perPage: 3 },
        420: { perPage: 2 },
      },
    }).mount();
  }

  // --- Main / Thumbs Sliders ---
  const mainSlider = document.getElementById('splide-main');
  const thumbsSlider = document.getElementById('splide-thumbs');
  if (mainSlider && thumbsSlider) {
    const main = new Splide(mainSlider, {
      type: 'slide',
      autoHeight: true,
      pagination: false,
      arrows: true,
      cover: true,
    });

    const thumbs = new Splide(thumbsSlider, {
      fixedWidth: 113,
      fixedHeight: 113,
      isNavigation: true,
      gap: 1,
      focus: 'center',
      pagination: false,
      cover: true,
      arrows: false,
      breakpoints: {
        640: { fixedWidth: 80, fixedHeight: 80 },
      },
    });

    main.sync(thumbs);
    main.mount();
    thumbs.mount();
  }

  // --- USP Bar Slider ---
  const uspBarSlider = document.querySelector('.usp-bar-slider');
  if (uspBarSlider) {
    new Splide(uspBarSlider, {
      type: 'fade',
      rewind: true,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 3000,
      speed: 800,
    }).mount();
  }

  mountRelatedProductsSplides();
}

// Run immediately if DOM is ready, otherwise wait
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSliders);
} else {
  initSliders();
}

document.addEventListener('shopify:section:load', (event) => {
  const sectionId = event?.detail?.sectionId;
  const section = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : event.target;
  mountRelatedProductsSplides(section || document);
});

document.addEventListener('related-products:updated', (event) => {
  const root = event.detail?.root || document;
  mountRelatedProductsSplides(root);
});
